import { PRICING_ENTRY_POINTS, PricingEntryPoint } from './pricingAttribution';

// Remembers which button started the pricing journey across the checkout redirect, so the app can react to
// where a purchase came from once it succeeds. Lives next to `rask_pending_subscription_checkout` with the same TTL.
const KEY = 'rask_pending_checkout_entry_point';
const TTL_MS = 24 * 60 * 60 * 1000;

type StoredCheckoutEntryPoint = {
  entryPoint: PricingEntryPoint;
  createdAt: number;
};

const isPricingEntryPoint = (value: unknown): value is PricingEntryPoint =>
  PRICING_ENTRY_POINTS.some((entryPoint) => entryPoint === value);

export const rememberCheckoutEntryPoint = (entryPoint: PricingEntryPoint) => {
  try {
    localStorage.setItem(
      KEY,
      JSON.stringify({ entryPoint, createdAt: Date.now() } satisfies StoredCheckoutEntryPoint),
    );
  } catch {}
};

export const clearCheckoutEntryPoint = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {}
};

export const readCheckoutEntryPoint = (): null | PricingEntryPoint => {
  try {
    const raw = localStorage.getItem(KEY);

    if (!raw) return null;

    const { entryPoint, createdAt } = JSON.parse(raw) as Partial<StoredCheckoutEntryPoint>;

    if (typeof createdAt !== 'number' || Date.now() - createdAt > TTL_MS || !isPricingEntryPoint(entryPoint)) {
      clearCheckoutEntryPoint();
      return null;
    }

    return entryPoint;
  } catch {
    return null;
  }
};
